<elements-stoplight-project
  [projectId]="feedProjectId"
  hideMocking="true"
  collapseTableOfContents="true"
  router="hash"
  hideExport="true"
></elements-stoplight-project>
